// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";

/**
 *
 * @export
 * @interface SimulateRainfallInput
 */
export interface SimulateRainfallInput {
  /**
   *
   */
  rainDuration?: number;
  /**
   *
   */
  rainIntensity?: number;
  /**
   *
   */
  schematisation: RanaFile;
  /**
   *
   */
  simulationDuration?: number;
}

/**
 * Check if a given object implements the SimulateRainfallInput interface.
 */
export function instanceOfSimulateRainfallInput(value: object): value is SimulateRainfallInput {
  if (!("schematisation" in value) || value["schematisation"] === undefined) return false;
  return true;
}

export function SimulateRainfallInputFromJSON(json: any): SimulateRainfallInput {
  return SimulateRainfallInputFromJSONTyped(json, false);
}

export function SimulateRainfallInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SimulateRainfallInput {
  if (json == null) {
    return json;
  }
  return {
    rainDuration: json["rain_duration"] == null ? undefined : json["rain_duration"],
    rainIntensity: json["rain_intensity"] == null ? undefined : json["rain_intensity"],
    schematisation: RanaFileFromJSON(json["schematisation"]),
    simulationDuration:
      json["simulation_duration"] == null ? undefined : json["simulation_duration"],
  };
}

export function SimulateRainfallInputToJSON(json: any): SimulateRainfallInput {
  return SimulateRainfallInputToJSONTyped(json, false);
}

export function SimulateRainfallInputToJSONTyped(
  value?: SimulateRainfallInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    rain_duration: value["rainDuration"],
    rain_intensity: value["rainIntensity"],
    schematisation: RanaFileToJSON(value["schematisation"]),
    simulation_duration: value["simulationDuration"],
  };
}
